module.exports = __webpack_public_path__ + "img/1_interesting.fcfdd8ad.png";